export default __webpack_public_path__ + "static/media/kcf_white_logo.e07599ad.webp";